import { render, staticRenderFns } from "./OrderReviews.vue?vue&type=template&id=16094392&scoped=true&"
import script from "./OrderReviews.vue?vue&type=script&lang=js&"
export * from "./OrderReviews.vue?vue&type=script&lang=js&"
import style0 from "./OrderReviews.vue?vue&type=style&index=0&id=16094392&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16094392",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VApp,VBtn,VImg,VRating})
